export const validateEmail = email => {
  if (!email) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = password => {
  return password && password.length >= 8;
};

export const validateRequired = value => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  return true;
};

export const validatePhone = phone => {
  if (!phone) return false;
  const digits = phone.toString().replace(/\D/g, '');
  return digits.length >= 7 && digits.length <= 15;
};

export const validateNumber = value => {
  if (value === null || value === undefined) return false;
  return !isNaN(value) && value !== '';
};

export const validateUrl = url => {
  if (!url) return false;
  try {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ); // fragment locator
    return !!pattern.test(url);
  } catch {
    return false;
  }
};

export const validateAuthForm = (data, type) => {
  if (type === 'login') {
    if (!validateRequired(data.email)) return 'Email is required.';
    if (!validateEmail(data.email)) return 'Please enter a valid email address.';
    if (!validateRequired(data.password)) return 'Password is required.';
  }

  if (type === 'forgot-password') {
    if (!validateRequired(data.email)) return 'Email is required.';
    if (!validateEmail(data.email)) return 'Please enter a valid email address.';
  }

  if (type === 'reset-password' || type === 'set-password') {
    if (!validateRequired(data.password)) return 'Password is required.';
    if (!validatePassword(data.password)) return 'Password must be at least 8 characters.';
    if (data.password !== data.confirmPassword && data.password !== data.confirm_password) {
      return 'Passwords do not match.';
    }
  }

  return null;
};
